import { combineReducers } from 'redux';
import * as storage from 'redux-storage';
import IAction, { Actions } from './actions';

const INITIAL_STATE = [];

const reducerActions = (state = INITIAL_STATE, action: IAction) => {
    switch (action.type) {
        case Actions.ADD_USER:
            return Object.assign({}, state, {
                user : action.payload
            });

        case Actions.CHOOSE_DOCUMENT:
            console.log('doc reducer' + action.payload);
            return [... state, {
                document: action.payload
            }];

        default:
        return state;
    }
    
}

const reducers = combineReducers({
    reducerActions
});

export default reducers;


// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/services/state/reducers.ts